import Swiper, { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";

class Module {
	constructor() {
		this.block = document.querySelector(".block-content-and-slider");
		if (this.block) {
			this.swiperElem = this.block.querySelector(".swiper-slides-images");
			this.swiperPagination = this.block.querySelector(".swiper-pagination");
			this.swiper = new Swiper(this.swiperElem, {
				modules: [Autoplay, Pagination],
				slidesPerView: 1,
				loop: true,
				autoHeight: true,
				autoplay: {
					delay: 3000,
				},
				pagination: {
					el: this.swiperPagination,
					clickable: true,
				},
			});
		}
	}
}
export default Module;
